import {
  Colours,
  StyleTokens,
  Fonts,
} from '@learningblocks/shared-components';

export const SWITCHED_OFF = {
  content: {
    display: 'flex',
    background: Colours.gradientBlues,
    borderRadius: StyleTokens.borderRadiusStandard,
    margin: '0px 0px 16px 0px',
  },
  content_left: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    backgroundColor: `rgba(255, 255, 255, 0.2)`,
    minWidth: '32%',
    maxWidth: '32%',
  },
  content_left__caution: {
    display: 'block',
    width: '140px',
    paddingBottom: '16px',
  },
  content_left__text: {
    color: Colours.colorNeutralWhite,
    margin: '0px',
    fontFamily: Fonts.fontButton,
    paddingBottom: '16px',
  },
  content_left__warning: {
    display: 'block',
    paddingBottom: '16px',
  },
  content_left__switch: {
    paddingBottom: '16px',
  },
  content_right: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
    minWidth: '58%',
    maxWidth: '58%',
  },
  board: {
    border: `${StyleTokens.lineThicknessThickest} solid ${Colours.colorPrimaryTone80}`,
    borderRadius: StyleTokens.borderRadiusStandard,
    backgroundColor: '#eba05a',
    width: '100%',
  },
  board_content: {
    backgroundColor: '#a05007',
    margin: '20px',
    padding: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  canvas: {
    width: '160px',
    height: '180px',
    backgroundColor: '#d6a364',
  },
};

export const SWITCHED_ON = {
  content: {
    display: 'flex',
    background: Colours.colorNeutralBlack,
    borderRadius: StyleTokens.borderRadiusStandard,
    margin: '0px 0px 16px 0px',
  },
  content_left: {
    display: 'flex',
    padding: '16px',
    flexDirection: 'column',
    backgroundColor: `rgba(255, 255, 255, 0.2)`,
    minWidth: '32%',
    maxWidth: '32%',
  },
  content_left__caution: {
    display: 'block',
    width: '140px',
    paddingBottom: '16px',
  },
  content_left__text: {
    color: Colours.colorNeutralWhite,
    margin: '0px',
    fontFamily: Fonts.fontButton,
    paddingBottom: '16px',
  },
  content_left__warning: {
    display: 'block',
    paddingBottom: '16px',
  },
  content_left__switch: {
    paddingBottom: '16px',
  },
  content_right: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px',
    minWidth: '58%',
    maxWidth: '58%',
  },
  board: {
    border: `${StyleTokens.lineThicknessThickest} solid #6a8b8f`,
    borderRadius: StyleTokens.borderRadiusStandard,
    backgroundColor: '#203239',
    width: '100%',
  },
  board_content: {
    backgroundColor: '#4c8daa',
    margin: '20px',
    padding: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  canvas: {
    width: '160px',
    height: '180px',
    backgroundColor: '#d6a364',
    ['pointer-events']: 'none',
  },
};
